import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface NodeDeleteButtonProps {
  onDelete?: () => void
  nombre?: string
}

export function NodeDeleteButton({ onDelete, nombre }: NodeDeleteButtonProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        title="Eliminar nodo"
        onClick={() => setOpen(true)}
        className="nodrag rounded p-1 text-gray-400 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-950"
      >
        <Trash2 size={13} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Eliminar nodo</DialogTitle>
            <DialogDescription>
              ¿Seguro que deseas eliminar {nombre ? `"${nombre}"` : 'este nodo'}? Esta
              acción no se puede deshacer.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" size="sm" onClick={() => setOpen(false)}>
              Cancelar
            </Button>
            <Button
              variant="destructive"
              size="sm"
              onClick={() => {
                setOpen(false)
                onDelete?.()
              }}
            >
              Eliminar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
